import React, { useState } from "react";
import Slider from "react-slick";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

export const Brand0 = ({ data }) => {
  const baseImageUrl = "https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/";
  const baseBackgroundImageUrl =
    "https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/";



    function lightenHexColor(hex, percent) {
      const num = parseInt(hex.replace("#", ""), 16);
      let r = (num >> 16) + 255 * percent;
      let g = ((num >> 8) & 0x00ff) + 255 * percent;
      let b = (num & 0x0000ff) + 255 * percent;
    
      r = Math.max(0, Math.min(255, Math.round(r)));
      g = Math.max(0, Math.min(255, Math.round(g)));
      b = Math.max(0, Math.min(255, Math.round(b)));
    
      return `rgb(${r}, ${g}, ${b})`;
    }
   
    function darkenHexColor(hex, percent) {
      const num = parseInt(hex.replace("#", ""), 16);
      let r = (num >> 16) - 255 * percent;
      let g = ((num >> 8) & 0x00ff) - 255 * percent;
      let b = (num & 0x0000ff) - 255 * percent;
    
      r = Math.max(0, Math.min(255, Math.round(r)));
      g = Math.max(0, Math.min(255, Math.round(g)));
      b = Math.max(0, Math.min(255, Math.round(b)));
    
      return `rgb(${r}, ${g}, ${b})`;
    }
  

  const brands = data.get_home_component_details.content.map((item, index) => ({
    id: index + 1,
    image: item.brand_image_app ? `${baseImageUrl}${item.brand_image_app}` : "",
    brandId: item.brand_auto_id,
    brandName: item.brand_name,
  }));

  const [currentSlide, setCurrentSlide] = useState(0);

  const PrevArrow = ({ onClick }) =>
    currentSlide > 0 ? (
      <div
        className="absolute left-0 bg-gray-800/50 hover:bg-gray-900 text-white rounded-full p-2 cursor-pointer z-10"
        style={{
          top: "50%",
          transform: "translateY(-50%)",
          left: window.innerWidth < 768 ? "[-20px]" : "[-80px]",
        }}
        onClick={onClick}
      >
        <IoIosArrowBack size={20} />
      </div>
    ) : null;

  const NextArrow = ({ onClick }) =>
    currentSlide < brands.length - 5 ? (
      <div
        className="absolute right-0 bg-gray-800/50 hover:bg-gray-900 text-white rounded-full p-2 cursor-pointer z-10"
        style={{
          top: "50%",
          transform: "translateY(-50%)",
          right: window.innerWidth < 768 ? "[-20px]" : "[-100px]",
        }}
        onClick={onClick}
      >
        <IoIosArrowForward size={20} />
      </div>
    ) : null;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // Mobile Landscape
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480, // Mobile Portrait
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div
      className="grid gap-1 relative p-4 bg-cover bg-center"
      style={{
        backgroundColor: data.web_background_color
      }}
    >
      {/* Title Section */}
      <div className={`grid text-${data.title_alignment}`}>
        <h2
          className={`font-${data.web_title_font}`}
          style={{ color: data.web_title_color }}
        >
          {data.title}
        </h2>
      </div>

      {/* Slick Slider */}
      <div className="relative flex justify-center text-center items-center mt-6 overflow-x-hidden ">
        <div className="w-full max-w-[90vw] md:max-w-screen-xl overflow-hidden">
          <Slider {...settings} className="flex">
            {brands.map((brand) => (
              <Link
                to="/brandlist"
                state={{
                  brand_id: brand.brandId,
                  brand_name: brand.brandName,
                }}
                className="text-decoration-none text-inherit"
              >
                <div key={brand.id} className="flex justify-center px-1 ml-0 ">
                  <img
                    src={brand.image}
                    alt="Not Found"
  className="rounded-sm object-cover h-32 w-44 sm:h-35 sm:w-64"
                  />
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
